import { apiClient } from "./ApiClient";

export default {
  listBoards() {
    return apiClient.get(`/api/monday/boards`);
  },
  listBoardItems(id, page_cursor = null) {
    let url = `/api/monday/board_items/${id}`;

    if (page_cursor) {
      url += `?page_cursor=${page_cursor}`;
    }

    return apiClient.get(url);
  },
  listBoardItemsForTable(board_id, table_id) {
    return apiClient.get(`/api/monday/board_items/${board_id}/${table_id}`);
  },
  getBoardItemMessages(item_id) {
    return apiClient.get(`/api/monday/board_item_messages/${item_id}`);
  },
  sendBoardItemMessage(item_id, body, files = []) {
    let form_data = new FormData();
    for (let i = 0; i < files.length; i++) {
      let file = files[i];
      form_data.append("files[" + i + "]", file);
    }

    // form_data.append("file", file);
    form_data.append("body", body);

    return apiClient
      .post(`/api/monday/board_item_messages/${item_id}`, form_data, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .catch(e => {
        console.log("error", e.response);
      });
  },
  getBoardItem(item_id) {
    return apiClient.get(`/api/monday/board_items/item/${item_id}`);
  },
  updateColumn(board_id, item_id, column_id, column_type, value) {
    return apiClient.put(`/api/monday/board_items/${board_id}/${item_id}`, {
      column_id,
      column_type,
      value
    });
  },
  addNewItem(board_id, item_name, group_id, column_values, board_columns) {
    return apiClient.post(`/api/monday/board_items/${board_id}`, {
      item_name,
      group_id,
      column_values,
      board_columns
    });
  },
  updateItem(board_id, item_id, column_values, board_columns, name) {
    return apiClient.put(
      `/api/monday/board_items/task_details/${board_id}/${item_id}`,
      {
        column_values,
        board_columns,
        name
      }
    );
  },
  deleteUpdate(update_id) {
    return apiClient.delete(`/api/monday/board_item_messages/${update_id}`);
  },
  getMe() {
    return apiClient.get(`/api/monday/user/me`);
  }
};
